import { createContext, useContext } from "react";

/** Portal target for kit overlays — keeps popovers inside .co-shell so --co-* tokens resolve. */
export const CoShellPortalContext = createContext<Element | null>(null);

export function useCoShellPortal() {
  return useContext(CoShellPortalContext);
}
